import stateClass, {CHANGE_EVENT, SELECT_EVENT} from '../baseState';

const TOGGLE_EVENT = 'toggle';
const ACTIVE_SCHOOL_EVENT = 'active_school';
const GROUP_TOGGLE_EVENT = 'students_group_toggle_event';

const ALL_STUDENTS_TT = 'Anonimizētu skolēnu dzīvesvietu aptuvens izvietojums';
const STUDENTS_SCHOOLS_TT = 'Anonimizētu skolēnu deklarēto dzīves vietu aptuvens izvietojums pēc apmeklētās izglītības iestādes 1.septembrī; apļa laukums proporcionāls skolēnu skaitam';
const MUNICIP_SCHOOLS_TT = 'Konkrētajā pašvaldībā deklarēto skolēnu apmeklētās skolas pēc skolēnu skaita no attiecīgās pašvaldības';

const ALL_STUDENTS = 'Visi skolēni';
const STUDENTS_BY_SCHOOLS = 'Skolēni pēc skolas';
const STUDENT_SCHOOLS_BY_MUNICIP = 'Pašvaldību deklarēto skolēnu skolas / izvēlēties pašvaldību';


class studentsClass extends stateClass {

	constructor(props) {
		super(props);

		this.active = false;

		this.activeSchools = [];

		this.data = [
			{name: ALL_STUDENTS, active: false, tooltip: ALL_STUDENTS_TT},
			{name: STUDENTS_BY_SCHOOLS, active: false, tooltip: STUDENTS_SCHOOLS_TT},
			{name: STUDENT_SCHOOLS_BY_MUNICIP, active: false, tooltip: MUNICIP_SCHOOLS_TT}
		];

		
	}

	setActiveGroup(name) {

		var active = false;
		this.recursiveDataLoop(function(item){

			if(item.name === name) {

				if(item.active) {
					item.active = false;
				} else {
					item.active = true;
					active = true;
				}
			} else {
				item.active = false;
			}

			
		});

		if(active && !this.active) {
			this.toggle(true);
		} else if(this.active) {
			this.toggle(false);
		}

		this.emit(GROUP_TOGGLE_EVENT);
	}

	getActiveGroup() {

		for (var i = this.data.length - 1; i >= 0; i--) {
			if(this.data[i].active){


				return this.data[i];
			}
		}
	}

	setDividedAsset(inst) {

		this.dividedAssets = inst;
	}

	getActive() {

		return this.active;
	}

	toggle() {

		if(this.active) {
			
			this.enable(false);
		} else {

			this.enable(true);
		}
	}

	enable(active) {

		this.active = active;
		this.emit(TOGGLE_EVENT);
	}

	setActiveSchools(school) {

		this.activeSchools = school;
		
		this.emit(ACTIVE_SCHOOL_EVENT);
	}

	getActiveSchoolsString() {

		return this.activeSchools.join(", ");
	}


}

var StudentsState = new studentsClass();

export {StudentsState, studentsClass, ACTIVE_SCHOOL_EVENT, CHANGE_EVENT, TOGGLE_EVENT, GROUP_TOGGLE_EVENT,
	STUDENTS_BY_SCHOOLS, ALL_STUDENTS, SELECT_EVENT, STUDENT_SCHOOLS_BY_MUNICIP};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/students/state.js